const sanitiseValue = (value) => {
      if (value === null || value === undefined) return "";
    
      if (typeof value === "object") {
        try {
          return `"${JSON.stringify(value)
            .replace(/"/g, '""')     // Escape quotes for CSV
            .replace(/\n/g, ' ')     // Remove newlines
            .replace(/\r/g, '')}"`;  // Wrap the entire string in quotes
        } catch {
          return '""';
        }
      }
    
      const str = String(value).replace(/"/g, '""');
      return `"${str}"`;
    };

  export const downloadCSV = async (data, filename) => {
    if (!data.length) {
      console.warn("Empty JSON array");
      return;
    }

    const headers = Object.keys(data[0]);
    const csvContent = [
      headers.join(","),
      ...data.map(row => headers.map(field => sanitiseValue(row[field])).join(",")) // Data rows
    ].join("\n");

    // Create a Blob and a download link
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    downloadFile(blob, filename);
}

  export const downloadFile = async (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

export const downloadFileFromUrl = async (url) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = '';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};